import { render, staticRenderFns } from "./RoyalTowerMap.vue?vue&type=template&id=4f88ffc4&scoped=true&"
import script from "./RoyalTowerMap.vue?vue&type=script&lang=js&"
export * from "./RoyalTowerMap.vue?vue&type=script&lang=js&"
import style0 from "./RoyalTowerMap.vue?vue&type=style&index=0&id=4f88ffc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88ffc4",
  null
  
)

export default component.exports